
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.899 33.856c0 .459-.283.763-.848.912a.407.407 0 00.096.096.96.96 0 00.72.32c.139.01.283-.053.432-.192.544-.544 1.099-2.15 1.664-4.816.299-1.387.677-3.403 1.136-6.048A228.539 228.539 0 019.683 7.056c.235-.896.41-1.563.528-2a37.17 37.17 0 01.56-1.712c.245-.715.501-1.285.768-1.712.277-.437.581-.773.912-1.008.352-.256.693-.384 1.024-.384.544 0 .981.176 1.312.528.33.352.512.79.544 1.312 0 .299-.08.539-.24.72-.16.181-.384.272-.672.272a.849.849 0 01-.624-.256.868.868 0 01-.256-.64c0-.459.283-.763.848-.912L14.34 1.2a1.978 1.978 0 00-.256-.208.932.932 0 00-.528-.16.274.274 0 00-.112.016c-.341.096-.688.63-1.04 1.6-.352.96-.741 2.523-1.168 4.688-.32 1.557-.613 3.163-.88 4.816A245.111 245.111 0 016.771 28.96c-.341 1.355-.63 2.39-.864 3.104-.395 1.195-.827 2.101-1.296 2.72-.48.672-1.061 1.008-1.744 1.008-.48 0-.89-.181-1.232-.544a2.01 2.01 0 01-.528-1.312c0-.299.08-.539.24-.72.16-.17.384-.256.672-.256.245 0 .453.085.624.256.17.17.256.384.256.64z","fill":"currentColor"}}),_c('rect',{attrs:{"x":"20.727","y":"12.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}})])
          )
        }
      }
    